import React, {
  useCallback,
  createContext,
  useContext,
  useState,
  useEffect
} from 'react';
import { useAuth } from 'hooks/useAuth/useAuth';
import { getDoneWithoutManifestJourneys, fetcher } from 'utils/network/http';
import useSWR from 'swr';

export const PendingPodsContext = createContext();

export const ProvidePendingPods = ({ children }) => {
  const pendingPods = useProvidePendingPods();
  return (
    <PendingPodsContext.Provider value={pendingPods}>
      {children}
    </PendingPodsContext.Provider>
  );
};

export const usePendingPods = () => {
  return useContext(PendingPodsContext);
};

const useProvidePendingPods = () => {
  const { termsAccepted } = useAuth();
  const [showDot, setShowDot] = useState(false);
  const [numberPendingJourneys, setNumberPendingJourneys] = useState(0);
  const {
    data: pendingPodsJourneysData,
    error,
    mutate: refetchPendingPods
  } = useSWR(termsAccepted ? getDoneWithoutManifestJourneys : null, fetcher, {
    refreshInterval: 60000
  });

  const getNumberOfPendingPods = useCallback(() => {
    const results = pendingPodsJourneysData?.data;
    return results ? results.length : 0;
  }, [pendingPodsJourneysData]);

  useEffect(() => {
    const pendingPodsFromServer = pendingPodsJourneysData?.data
      ? pendingPodsJourneysData?.data?.length
      : 0;

    if (pendingPodsFromServer > numberPendingJourneys) {
      setShowDot(true);
    }
    setNumberPendingJourneys(pendingPodsFromServer);
  }, [pendingPodsJourneysData, numberPendingJourneys]);

  const setViewedJourneys = () => setShowDot(false);

  return {
    pendingPodsJourneys: pendingPodsJourneysData?.data || [],
    error,
    numberOfPendingPods: getNumberOfPendingPods(),
    loading: !pendingPodsJourneysData,
    showDot,
    setViewedJourneys,
    refetchPendingPods
  };
};
